import { capworksSignupService } from "@/modules/capworks/features/signup/store/services/capworks-signup-service";

const verifyEmailEndpoint = capworksSignupService.injectEndpoints({
  endpoints: (builder) => ({
    verifyEmail: builder.mutation({
      query: ({ email, token, pageUrl }) => ({
        url: "auth/signup/verify-email",
        method: "POST",
        body: { email, token, pageUrl },
      }),
      extraOptions: { suppressNotification: true },
    }),
  }),
  overrideExisting: false,
});

export const { useVerifyEmailMutation } = verifyEmailEndpoint;

